(() => {
  if (customElements.get('sk-tilvalg')) return;
  customElements.define('sk-tilvalg', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-open-product]');
        if (trigger) {
          event.preventDefault();
          this.opener = trigger;
          this.activeRow = trigger.closest('[data-option]');
          const body = this.querySelector('[data-dialog-body]');
          body.replaceChildren(this.activeRow.querySelector('template').content.cloneNode(true));
          // Product descriptions may contain legacy HTML. Do not execute embedded scripts.
          body.querySelectorAll('script, iframe, object, embed').forEach(node => node.remove());
          body.querySelectorAll('*').forEach(node => [...node.attributes].forEach(attr => {
            if (/^on/i.test(attr.name) || (/^(href|src|action)$/i.test(attr.name) && /^\s*javascript:/i.test(attr.value))) node.removeAttribute(attr.name);
          }));
          const selected = this.activeRow.querySelector('[data-variant]')?.selectedOptions[0];
          if (selected) { body.querySelector('[data-dialog-price]').textContent = this.money(Number(selected.dataset.price)); const sku = body.querySelector('[data-dialog-sku]'); if (sku) sku.textContent = selected.dataset.sku || 'Ikke oppgitt'; }
          const choose = body.querySelector('[data-dialog-select]');
          const checkbox = this.activeRow.querySelector('[data-selected]');
          if (choose && checkbox) { choose.disabled = checkbox.disabled; choose.textContent = checkbox.checked ? 'Fjern fra valgte tilbehør' : 'Velg dette tilbehøret'; }
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close-dialog]')) this.dialog.close();
        const imageButton = event.target.closest('[data-image-url]');
        if (imageButton) this.dialog.querySelector('[data-large-image]').src = imageButton.dataset.imageUrl;
        if (event.target.closest('[data-dialog-select]')) {
          const checkbox = this.activeRow?.querySelector('[data-selected]');
          if (checkbox && !checkbox.disabled) { checkbox.checked = !checkbox.checked; this.update(); }
          this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => this.opener?.focus());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
      if (!this.querySelector('[data-main]')) return;
      this.addEventListener('change', () => this.update());
      this.addEventListener('input', () => this.update());
      this.addEventListener('click', event => {
        const row = event.target.closest('[data-option]');
        if (!row || event.target.closest('a, input, select, option, label, button')) return;
        const checkbox = row.querySelector('[data-selected]');
        if (checkbox && !checkbox.disabled) { checkbox.checked = !checkbox.checked; this.update(); }
      });
      this.querySelector('[data-buy]').addEventListener('click', () => this.buy(true));
      this.querySelector('[data-buy-accessories]').addEventListener('click', () => this.buy(false));
      this.querySelector('[data-cart-refresh]').addEventListener('click', () => this.refreshCart().catch(() => {}));
      this.update();
      this.refreshCart().catch(() => {});
    }
    mainInCart() {
      if (this.dataset.purchase) return false;
      const id = this.querySelector('[data-main]').value;
      return (this.cartItems || []).some(item => String(item.variant_id ?? item.id) === String(id) && item.quantity > 0);
    }
    async refreshCart() {
      try {
        const response = await fetch(this.dataset.root + 'cart.js', {headers: {'Accept':'application/json'}, cache:'no-store'});
        if (!response.ok) throw Error('Kunne ikke kontrollere handlekurven.');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw Error('Ufullstendig svar fra handlekurven.');
        this.cartItems = cart.items;
        this.cartError = false;
      } catch (error) {
        this.cartItems = null;
        this.cartError = true;
        throw error;
      } finally { this.update(); }
    }
    items(includeMain = true) {
      const main = this.querySelector('[data-main]');
      const quantity = Number(this.querySelector('[data-main-quantity]').value);
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100 || (includeMain && (!main.selectedOptions[0] || main.selectedOptions[0].disabled || (this.dataset.purchase && Number(main.selectedOptions[0].dataset.price) <= 0)))) throw Error('Velg en tilgjengelig variant og et antall mellom 1 og 100.');
      const items = includeMain ? [{id: main.value, quantity, price: Number(main.selectedOptions[0].dataset.price)}] : [];
      this.querySelectorAll('[data-option]').forEach(row => {
        if (!row.querySelector('[data-selected]:checked')) return;
        const select = row.querySelector('[data-variant]');
        if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) throw Error('Et tilbehør er utilgjengelig. Velg en annen variant.');
        items.push({id: select.value, quantity: quantity * Number(row.dataset.quantity), price: Number(select.selectedOptions[0].dataset.price), properties: {_sk_tilvalg_for: this.dataset.product}});
      });
      return items;
    }
    money(value) {
      return new Intl.NumberFormat(document.documentElement.lang || 'nb', {style:'currency', currency:this.dataset.currency || 'NOK'}).format(value / 100);
    }
    update() {
      this.querySelectorAll('[data-option]').forEach(row => {
        const variant = row.querySelector('[data-variant]')?.selectedOptions[0];
        const price = row.querySelector('[data-option-price]');
        if (variant && price) price.textContent = this.money(Number(variant.dataset.price) * Number(row.dataset.quantity));
      });
      const accessoryButton = this.querySelector('[data-buy-accessories]');
      try {
        const accessories = this.items(false);
        this.querySelector('[data-accessory-total]').textContent = this.money(accessories.reduce((sum, item) => sum + item.quantity * item.price, 0));
        accessoryButton.disabled = !!this.busy || accessories.length === 0;
      } catch (_) {
        this.querySelector('[data-accessory-total]').textContent = 'Kontroller valg';
        accessoryButton.disabled = true;
      }
      const inCart = this.mainInCart();
      const known = Array.isArray(this.cartItems);
      const status = this.querySelector('[data-cart-status]');
      status.textContent = !known ? (this.cartError ? 'Handlekurven kunne ikke kontrolleres. Prøv igjen, eller kjøp bare tilbehør.' : 'Kontrollerer handlekurven …') : (inCart ? 'Denne aggregatvarianten ligger allerede i handlekurven. Vi legger bare til valgt tilbehør. Antallet nedenfor gjelder tilbehørssett.' : 'Aggregatet og valgt tilbehør legges til sammen.');
      this.querySelector('[data-cart-refresh]').hidden = !this.cartError;
      this.querySelector('[data-total-label]').textContent = inCart ? 'Tilbehør som legges til' : 'Samlet pris';
      const buyButton = this.querySelector('[data-buy]');
      const selectedMain = this.querySelector('[data-main]').selectedOptions[0];
      buyButton.textContent = inCart ? 'Legg valgt tilbehør i handlekurven' : 'Legg aggregat og valgte tilbehør i handlekurven';
      if (this.dataset.purchase) buyButton.textContent = selectedMain?.dataset.tracked && Number(selectedMain.dataset.stock) <= 0 && selectedMain.dataset.policy === 'continue' ? 'Bestill →' : 'Legg i handlekurv →';
      this.querySelector('[data-buy-accessories]').closest('.sk-tilvalg__accessories-only').hidden = inCart || !!this.dataset.purchase;
      try {
        const total = this.items(!inCart).reduce((sum, item) => sum + item.quantity * item.price, 0);
        this.querySelector('[data-total]').textContent = this.money(total);
        this.querySelector('[data-buy]').disabled = !!this.busy || !known || (inCart && this.items(false).length === 0);
      } catch (_) {
        this.querySelector('[data-total]').textContent = 'Kontroller valg';
        this.querySelector('[data-buy]').disabled = true;
      }
    }
    async buy(includeMain = true) {
      if (this.busy) return;
      const button = this.querySelector('[data-buy]'), message = this.querySelector('[data-message]');
      this.busy = true;
      this.update();
      try {
        if (includeMain) {
          message.textContent = 'Kontrollerer handlekurven …';
          await this.refreshCart();
          includeMain = !this.mainInCart();
        }
        const items = this.items(includeMain).map(({price, ...item}) => item);
        if (!items.length) throw Error('Velg minst ett tilbehør.');
        this.busy = true; button.disabled = true; this.querySelector('[data-buy-accessories]').disabled = true; message.textContent = 'Legger til …';
        const response = await fetch(this.dataset.root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw Error(result.description || 'Kunne ikke legge til alle varene.');
        location.assign(this.dataset.root + 'cart');
      } catch (error) {
        message.textContent = error.message + ' Kontroller handlekurven før du prøver igjen.';
        const link = document.createElement('a'); link.href = this.dataset.root + 'cart'; link.textContent = ' Åpne handlekurven'; message.append(link);
      } finally { this.busy = false; this.update(); }
    }
  });
})();
